import { useState } from "react";
import { searchPlaces, type Place } from "../lib/places";

/** "Find on Google Maps" for a new venue: up to five places; picking one fills the venue and links it. One search per tap. */
export function VenueFinder({ query, onPick }: { query: string; onPick: (p: Place) => void }) {
  const [results, setResults] = useState<Place[] | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const find = async () => {
    setBusy(true);
    setError(null);
    try {
      setResults(await searchPlaces(query));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="vfind">
      <button type="button" className="btn ghost sm" disabled={busy || !query.trim()} onClick={find}>
        {busy ? "Searching…" : "Find on Google Maps"}
      </button>
      {error && <p className="error">{error}</p>}
      {results &&
        (results.length ? (
          <div className="places" role="group" aria-label="Google Maps results">
            {results.map((p) => (
              <button type="button" key={p.place_id} onClick={() => { onPick(p); setResults(null); }}>
                <b>{p.name}</b>
                <span>{p.address}</span>
              </button>
            ))}
          </div>
        ) : (
          <p className="faint" style={{ margin: 0, fontSize: 12 }}>Google Maps found nothing for that. Type the address instead.</p>
        ))}
    </div>
  );
}
